import React, { useEffect, useState } from "react";
import Header from "../../../Shared/Header/Header";
import { useNavigate } from "react-router-dom";
import ReactGA from "react-ga4";
const FailedGiftCard = () => {
  const [countDown, setCountdown] = useState(3);
  const navigate = useNavigate();
  useEffect(() => {
    if (countDown == 0) {
      navigate("/gift-card");
    }

    const countdownInterval = setInterval(() => {
      setCountdown((prevCountdown) => prevCountdown - 1);
    }, 1000);

    // Clear the timeout when the component unmounts to avoid memory leaks
    return () => {
      clearInterval(countdownInterval);
    };
  }, [countDown]);

  useEffect(() => {
    ReactGA.send({
      hitType: "pageview",
      page: `${window.location.pathname + window.location.search}`,
      title: "Failed Gift Card Payment",
    });
  }, []);
  return (
    <div>
      <Header></Header>
      <p style={{ margin: "5% 0", textAlign: "center" }}>
        Failed gift card payment. Redirecting to gift card page in {countDown}{" "}
        seconds..
      </p>
    </div>
  );
};

export default FailedGiftCard;
